<template>
  <a-popover
    :title="false"
    :footer="false"
    overlayClassName="support-popover-overlay"
    placement="right"
  >
    <template slot="content">
      <div class="dash-text__16 dash-text__500">
        {{ $t("Support info") }}
      </div>
    </template>

    <div class="support-button demo__pointer">
      <span>
        {{ $t("Support") }}
      </span>
    </div>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    user: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isSent: false,
    };
  },
  watch: {
    user() {
      this.setChatwootUser();
    },
  },
  beforeDestroy() {
    window.removeEventListener("chatwoot:ready", this.setChatwootUser);
  },
  created() {
    window.addEventListener("chatwoot:ready", this.setChatwootUser);
  },
  mounted() {
    this.setChatwootUser();
  },
  methods: {
    setChatwootUser() {
      if (!this.user || this.isSent) return;
      this.$nextTick(() => {
        if (window.$chatwoot) {
          const form = {
            email: this.user.email,
            identifier_hash: this.user.identifierHash,
            name: this.user.fullName || this.user.username,
            phone_number: this.user.phone,
          };
          window.$chatwoot.setUser(this.user.id + "", form);
          this.$debug(
            "CHATWOOT: setUser " + this.user.id + " -> ",
            "warning",
            JSON.stringify(form)
          );
          this.isSent = true;
        }
      });
    },
  },
};
</script>
